module.exports = __webpack_public_path__ + "static/img/title-shhh.5fc40bd0.png";